import { c as _c } from "react/compiler-runtime";
import { Breadcrumb } from "@website/ui/breadcrumb";
import { getOrigin } from "@website/utils/channel/get-origin";
import { useRouter } from "next/router";
interface Properties {
  tourFromToDestDesc: string;
}
export function PageBreadcrumb(t0) {
  const $ = _c(8);
  const {
    tourFromToDestDesc
  } = t0;
  const {
    query
  } = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      title: "\u062A\u0648\u0631",
      href: `${getOrigin()}/tour`
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== query) {
    t2 = {
      pathname: "/[origin]/[dest]",
      query
    };
    $[1] = query;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2 || $[4] !== tourFromToDestDesc) {
    t3 = [t1, {
      title: tourFromToDestDesc,
      href: t2
    }];
    $[3] = t2;
    $[4] = tourFromToDestDesc;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const list = t3;
  let t4;
  if ($[6] !== list) {
    t4 = <section className="my-5 max-lg:hidden md:px-6 xl:mx-auto xl:w-[1200px] xl:px-0"><Breadcrumb color="default" list={list} /></section>;
    $[6] = list;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}